import { defineProperty as _defineProperty, inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, assertThisInitialized as _assertThisInitialized, createClass as _createClass, toConsumableArray as _toConsumableArray, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { marginBottomLevels, Theme, gridStyles, getMarginBottomClass, eventBus, Reveal, Link, IconAddThick } from '@piggybank/core';
import omit from 'lodash/fp/omit';
import { connect, getIn, FieldArray } from 'formik';
import { TransitionGroup, Transition } from 'react-transition-group';
import styles from './add-another.css.js';
import AddAnotherItem from './AddAnotherItem.js';

var AddAnother = /*#__PURE__*/function (_Component) {
  _inherits(AddAnother, _Component);

  function AddAnother() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AddAnother);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AddAnother)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      counter: 0,
      ids: []
    });

    return _this;
  }

  _createClass(AddAnother, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          name = _this$props.name,
          minOnMount = _this$props.minOnMount,
          itemInitialValue = _this$props.itemInitialValue,
          formik = _this$props.formik;
      var formInitialValues = getIn(formik.values, name) || [];

      if (minOnMount > formInitialValues.length) {
        var i = 0,
            fieldInitialValues = [];

        while (i < minOnMount) {
          fieldInitialValues.push(itemInitialValue);
          i++;
        } // https://github.com/jaredpalmer/formik/issues/930


        setTimeout(function () {
          formik.setFieldValue(name, [].concat(_toConsumableArray(formInitialValues), _toConsumableArray(fieldInitialValues.slice(formInitialValues.length))));
        }, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cn,
          _this2 = this;

      var _omit = omit(['onRemove', 'onAdd', 'minOnMount'], this.props),
          name = _omit.name,
          min = _omit.min,
          max = _omit.max,
          formik = _omit.formik,
          itemInitialValue = _omit.itemInitialValue,
          showAdd = _omit.showAdd,
          focusFirstInput = _omit.focusFirstInput,
          addInfoSlot = _omit.addInfoSlot,
          duration = _omit.duration,
          easing = _omit.easing,
          marginBottom = _omit.marginBottom,
          fullWidth = _omit.fullWidth,
          textMap = _omit.textMap,
          renderRemoveButtonText = _omit.renderRemoveButtonText,
          renderAddButtonText = _omit.renderAddButtonText,
          children = _omit.children,
          rest = _objectWithoutProperties(_omit, ["name", "min", "max", "formik", "itemInitialValue", "showAdd", "focusFirstInput", "addInfoSlot", "duration", "easing", "marginBottom", "fullWidth", "textMap", "renderRemoveButtonText", "renderAddButtonText", "children"]);

      var currentValue = getIn(formik.values, name);
      var length = Array.isArray(currentValue) ? currentValue.length : 0;
      var lengthChanged = this.lengthChanged;
      this.lengthChanged = false;
      var strongLink = Theme.select({
        redbrand: false,
        mands: true
      });
      return React.createElement("div", _extends({
        className: cn((_cn = {}, _defineProperty(_cn, styles.fullWidth, fullWidth), _defineProperty(_cn, gridStyles['size-12'], !fullWidth), _defineProperty(_cn, gridStyles['sizeMedium-7'], !fullWidth), _defineProperty(_cn, gridStyles['sizeLarge-4'], !fullWidth), _cn), getMarginBottomClass(marginBottom))
      }, rest), React.createElement(FieldArray, {
        name: name
      }, function (arrayHelpers) {
        return React.createElement(React.Fragment, null, React.createElement(TransitionGroup, {
          component: null
        }, _this2.state.ids.map(function (id, index) {
          return React.createElement(Transition, {
            timeout: {
              enter: 20,
              exit: duration + 50
            },
            key: id
          }, function (state) {
            return React.createElement(AddAnotherItem, {
              state: state,
              showRemove: length > min,
              onRemove: function onRemove(event) {
                arrayHelpers.remove(index);
                _this2.lengthChanged = true;

                _this2.setState({
                  ids: _this2.state.ids.filter(function (id, i) {
                    return i !== index;
                  })
                });

                eventBus.dispatch({
                  type: 'onRemove',
                  component: 'AddAnother',
                  name: name,
                  index: index
                });

                if (_this2.props.onRemove) {
                  _this2.props.onRemove(event);
                }
              },
              removeButtonText: renderRemoveButtonText ? renderRemoveButtonText({
                index: index
              }) : textMap.removeButton,
              focus: lengthChanged && index === _this2.state.ids.length - 1,
              focusFirstInput: focusFirstInput,
              duration: duration,
              easing: easing
            }, children({
              path: state !== 'exiting' ? "".concat(name, ".").concat(index) : 'NO_PATH',
              index: index
            }));
          });
        })), React.createElement(Reveal, {
          animateOpacity: true,
          duration: 150
        }, showAdd && length < max && React.createElement(React.Fragment, null, addInfoSlot && React.createElement("div", {
          className: cn(_defineProperty({}, styles.addInfoSlotPadding, length)) || null
        }, addInfoSlot), React.createElement(Link, {
          elementType: "button",
          type: "button",
          strong: strongLink,
          iconSlotLeft: React.createElement(IconAddThick, {
            inline: true
          }),
          onClick: function onClick(event) {
            arrayHelpers.push(itemInitialValue);
            _this2.lengthChanged = true;
            eventBus.dispatch({
              type: 'onAdd',
              component: 'AddAnother',
              name: name,
              index: length
            });

            if (_this2.props.onAdd) {
              _this2.props.onAdd(event);
            }
          },
          hoverUnderline: true,
          buttonPadding: true
        }, renderAddButtonText ? renderAddButtonText({
          length: length
        }) : textMap.addButton))));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Assumption: New items are added at the end only
      var values = getIn(props.formik.values, props.name);
      var newItemsCount = (Array.isArray(values) ? values.length : 0) - state.ids.length;

      if (newItemsCount > 0) {
        var newIds = [];
        var i = 0;

        while (i < newItemsCount) {
          newIds.push(state.counter + i);
          i++;
        }

        return {
          ids: [].concat(_toConsumableArray(state.ids), newIds),
          counter: state.counter + i
        };
      } else if (newItemsCount < 0) {
        return {
          ids: state.ids.slice(0, newItemsCount)
        };
      }

      return null;
    }
  }]);

  return AddAnother;
}(Component);

_defineProperty(AddAnother, "defaultProps", {
  min: 0,
  minOnMount: 0,
  max: Infinity,
  showAdd: true,
  focusFirstInput: true,
  duration: 200,
  easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  marginBottom: 5,
  fullWidth: false,
  textMap: {
    addButton: 'Add another',
    removeButton: 'Remove'
  }
});

AddAnother.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,

  /** docgen-from-context:<Form/> */
  formik: PropTypes.object.isRequired,
  showAdd: PropTypes.bool,
  focusFirstInput: PropTypes.bool,
  addInfoSlot: PropTypes.node,
  itemInitialValue: PropTypes.any.isRequired,
  duration: PropTypes.number,
  easing: PropTypes.string,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  fullWidth: PropTypes.bool,
  textMap: PropTypes.shape({
    addButton: PropTypes.node,
    removeButton: PropTypes.node
  }),
  renderRemoveButtonText: PropTypes.func,
  renderAddButtonText: PropTypes.func,
  children: PropTypes.func.isRequired,
  minOnMount: PropTypes.number,

  /**
   * proxied to eventBus
   */
  onRemove: PropTypes.func,

  /**
   * proxied to eventBus
   */
  onAdd: PropTypes.func
} : {};
var connected = connect(AddAnother);
connected.displayName = 'AddAnother';
export default connected;
export { AddAnother };